import { HTTP } from "../../../services/http"

export const ContactoService = {
    send (data) {
        return HTTP.post('/send-email', data)
    }
}